import { ConfigProvider } from 'antd';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import routes from './config/routes';
import zhCN from 'antd/locale/zh_CN';
import moment from "moment";
import "moment/locale/zh-cn";
import { StyleProvider } from '@ant-design/cssinjs';
import 'dayjs/locale/zh-cn';
import dayjs from "dayjs";
import "@ant-design/flowchart/dist/index.css"

dayjs.locale('zh-cn');

moment.locale("zh-cn");

export default () => {


  const renderRoute = (route: any, index: number) => {

    const hasChildren = route.children ? true : false;
    const children = hasChildren ? [...route.children] : [];
    return (
        <Route key={route.path ?? `route-${index}`} path={route.path} index={route.index} element={

          hasChildren ? <route.layout>
            <Routes>
              {children.map((it, i) => {
                return renderRoute(it, i);
              })}
            </Routes>
          </route.layout> : <route.component />
        } >
        </Route>
    )


  };

  return (
    <>

      <StyleProvider hashPriority="high">
       


          <ConfigProvider locale={zhCN} theme={{
            token: {
              colorPrimary: "#F90007",
            }
          }} >
            <BrowserRouter>
              <Routes>

                {routes.map((it, i) => renderRoute(it, i))}


              </Routes>
            </BrowserRouter>
          </ConfigProvider>
   
      </StyleProvider>
    </>
  )

};
